import React from 'react';
import Placeholder from 'components/general/Placeholder/Placeholder';
import classNames from 'classnames';
import { pure } from 'recompose';

const CountryFlag: React.SFC<CountryFlagProps> = ({ iso }) => (
  <Placeholder
    width={4}
    height={3}
    className="country-flag"
    background
  >
    <span
      className={classNames(
        'flag-icon',
        'placeholder__img',
        { [`flag-icon--${iso}`]: iso },
      )}
    />
  </Placeholder>
);

export interface CountryFlagProps {
  iso?: string;
}

export default pure(CountryFlag);

